import React from 'react';
import { Typography } from 'rmwc';

export function Text(props) {
  const tags = {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading2: 'h3',
    subheading1: 'h4',
    body1: 'p',
    body2: 'aside',
    caption: 'span',
  };
  return (
    <Typography tag={tags[props.use]} adjustMargin={true} {...props}>
      {props.children}
    </Typography>
  );
}

export default Text;
